export { default } from './TableCell';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableCell/index.js
// module id = 341
// module chunks = 0